import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { errorMessage } from './Login';
import AuthShell from '../components/AuthShell';
import { errorBox, input, label, link, primaryBtn, successBox } from '../components/authStyles';

const API_URL = process.env.REACT_APP_API_URL || '';

// Destino do link de redefinição: valida o token e define a nova senha.
function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [checking, setChecking] = useState(true);
  const [loading, setLoading] = useState(false);
  const [linkError, setLinkError] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!token) {
      setLinkError('Link de redefinição incompleto.');
      setChecking(false);
      return;
    }
    axios
      .get(`${API_URL}/api/auth/password/reset/verify`, { params: { token } })
      .then(({ data }) => setEmail(data.email))
      .catch((err) => setLinkError(errorMessage(err, 'Link inválido.')))
      .finally(() => setChecking(false));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setError('As senhas não conferem.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API_URL}/api/auth/password/reset`, { token, password });
      setDone(true);
    } catch (err) {
      setError(errorMessage(err, 'Não foi possível alterar a senha'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Definir nova senha">
      {checking && <p className="text-sm text-slate-400">Validando link…</p>}

      {!checking && linkError && (
        <div>
          <div className={errorBox}>{linkError}</div>
          <p className="text-center text-sm">
            <Link to="/login" className={link}>Voltar e solicitar um novo link</Link>
          </p>
        </div>
      )}

      {!checking && !linkError && done && (
        <div>
          <p className={successBox}>
            Senha alterada. Entre com a nova senha — um código será enviado ao seu e-mail.
          </p>
          <p className="mt-5 text-center text-sm">
            <Link to="/login" className={link}>Ir para o login</Link>
          </p>
        </div>
      )}

      {!checking && !linkError && !done && (
        <form onSubmit={submit} className="flex flex-col gap-4">
          {error && <div className={errorBox}>{error}</div>}
          <label className={label}>
            E-mail
            <input type="email" value={email} disabled autoComplete="username" className={input} />
          </label>
          <label className={label}>
            Nova senha (mínimo 8 caracteres)
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} autoComplete="new-password" className={input} />
          </label>
          <label className={label}>
            Confirmar nova senha
            <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={8} autoComplete="new-password" className={input} />
          </label>
          <button type="submit" className={primaryBtn} disabled={loading}>
            {loading ? 'Salvando…' : 'Salvar nova senha'}
          </button>
        </form>
      )}
    </AuthShell>
  );
}

export default ResetPassword;
